enum CategoryType {
  STANDARD = 'STANDARD',
  PIZZA = 'PIZZA',
  PIE = 'PIE',
  LASAGNA = 'LASAGNA',
  ALL_YOU_CAN_EAT = 'ALL_YOU_CAN_EAT',
}
export default CategoryType;
